import { render, staticRenderFns } from "./RegistryLicenseProfile.vue?vue&type=template&id=394b70fc&scoped=true"
import script from "./RegistryLicenseProfile.vue?vue&type=script&lang=js"
export * from "./RegistryLicenseProfile.vue?vue&type=script&lang=js"
import style0 from "./RegistryLicenseProfile.vue?vue&type=style&index=0&id=394b70fc&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "394b70fc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gl-apistage/apistage.greenlists.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('394b70fc')) {
      api.createRecord('394b70fc', component.options)
    } else {
      api.reload('394b70fc', component.options)
    }
    module.hot.accept("./RegistryLicenseProfile.vue?vue&type=template&id=394b70fc&scoped=true", function () {
      api.rerender('394b70fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/registry/RegistryLicenseProfile.vue"
export default component.exports